import AccountTypes from './AccountTypes';

const initialState = {
  categories: [],
  selected: [],
  accountDetail: {},
  showModal: false,
  accountSettings: {},
  passwordRegexSettings: {}
};

export default function accountReducer (state = initialState, action) {
  const {
    type,
    payload
  } = action;
  let newState = { ...state };
  switch (type) {
    case AccountTypes.GET_ACCOUNT_SETTING_SUCCESS:
      newState.accountDetail = { ...payload };
      return newState;
    case AccountTypes.SET_SHOW_MODAL:
      newState.showModal = payload;
      return newState;
    case AccountTypes.GET_ACCOUNT_SETTING_DETAIL_SUCCESS:
      newState.accountSettings = payload;
      return newState;
    case AccountTypes.GET_PASSWORD_REGEX_SUCCESS:
      newState.passwordRegexSettings = payload;
      return newState;
    default:
      newState = state;
      break;
  }

  // return new state
  return newState;
}
